export default __webpack_public_path__ + "static/media/giropay.f6b86a58.svg";